import { render, staticRenderFns } from "./LoginControl.vue?vue&type=template&id=bf31f060"
import script from "./LoginControl.vue?vue&type=script&lang=js"
export * from "./LoginControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports